import { Partner } from '@kanda-libs/ks-frontend-services';

export const formatAddress = (partner?: Partner) => ({
  buildingName: partner?.contact_info?.contact_address?.building_name,
  buildingNumber: partner?.contact_info?.contact_address?.building_number,
  line1: partner?.contact_info?.contact_address?.line_1 || 'Not added',
  line2: partner?.contact_info?.contact_address?.line_2,
  city: partner?.contact_info?.contact_address?.city || 'Not added',
  postcode: partner?.contact_info?.contact_address?.postcode || 'Not added',
});
